import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSearchResultValue as getValue } from '@zurich/search/utils';
import { ResultCardContentStyled, ResultCardStyled, } from '@zurich/ui/legacy/components';
import { ResultCardContractContent } from './ResultCardContractContent';
import { ResultCardContractHeader } from './ResultCardContractHeader';
export const ResultCardContract = ({ result, searchValue, active, size, TitleWrapComponent, }) => {
    const partyId = getValue(result, 'partyId');
    const policyNo = getValue(result, 'policyNo');
    if (!partyId || !policyNo) {
        console.error('Invalid search result for contract:', partyId, policyNo);
        return null;
    }
    const WrapComponent = TitleWrapComponent ?? (({ children }) => _jsx(_Fragment, { children: children }));
    const isSmall = size === 'small';
    return (_jsxs(ResultCardStyled, { active: active, tabIndex: 0, role: "button", "data-name": "search-result-card-contract", children: [_jsxs(ResultCardContentStyled, { children: [_jsx(ResultCardContractHeader, { result: result, TitleWrapComponent: WrapComponent, searchValue: searchValue, isSmall: isSmall }), _jsx(ResultCardContractContent, { result: result, searchValue: searchValue, isSmall: isSmall })] }), ' '] }));
};
